export enum PowerBIEventType {
    DataSelected = 1,
    HyperlinkClicked = 2
}